<div class="infor" *ngIf="tumblrPost">
    <p class="tumblr"><a href="{{tumblrLink}}" target="new">
        <span class="icon"><img src="{{tumblrAvatar}}" alt="{{tumblrName}}"></span>
        Tumblr</a>
    </p>
</div>
<div class="tumblr-post" *ngIf="tumblrPost">
    <div class="row">
        <div class="col-lg-2 col-xs-3 col-md-2 col-sm-3 item"  *ngFor="let media of tumblrPost">
            <div class="card">
                <div class="card-image">
                    <a href="{{media.post_url}}" target="new">
                        <img src="{{media.photos[0].alt_sizes[4].url}}" class="card-img-top" alt="{{media.blog.description}}">
                    </a>                    
                </div>
                <div class="card-body">
                    <div class="body-wrapper">                                
                    <div class="siteTitle">
                        <span>{{media.summary}}</span>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>